import React from 'react';

import SagitarioLogo from 'assets/images/sagitario-logo.png';

import * as S from './styles';

const SuperInfo = () => (
  <S.Container>
    <S.Logo src={SagitarioLogo} alt="Logotipo Sagitário" />
  </S.Container>
);

export default SuperInfo;
